import { MixpanelInAppMessaging } from './mixpanel-in-app-messaging'
import mixpanel from 'mixpanel-browser'

const iam = new MixpanelInAppMessaging(mixpanel)
iam.init()
